import { Injectable } from '@angular/core';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import {
	ActiveProductReport,
	_,
} from '@mira-avant/mtlibs';
import { ApiService } from './api.service';

@Injectable({
	providedIn: 'root',
})
export class ActiveProductsReports {
	private readonly BASE_PATH = 'reporting';

	public loading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

	constructor(private api: ApiService) {}

	private async withLoading<T>(operation: () => Promise<T>): Promise<T> {
		this.loading$.next(true);
		try {
			return await operation();
		} finally {
			this.loading$.next(false);
		}
	}

	public async getActiveProductsReport$(): Promise<ActiveProductReport[]> {
		return this.withLoading(async () => {
			return firstValueFrom(
				this.api.post<ActiveProductReport[]>(`${this.BASE_PATH}/active-products-report`,{})
			);
		});
	}
}
